import { render, staticRenderFns } from "./removeLevel.vue?vue&type=template&id=24e9980a&"
import script from "./removeLevel.vue?vue&type=script&lang=js&"
export * from "./removeLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports